export const shouldDisplay = (({ hideConditionalPromoDescription, data }) => {
  const { shortDesc } = data?.product?.pricing?.promotion?.description || {};
  return !!(data && !hideConditionalPromoDescription && shortDesc);
});

export const shouldHidePromotion = (({ hiddenPromos, data }) => {
  const { experienceTag, subExperienceTag } = data?.product?.pricing?.promotion || {};

  return hiddenPromos.some((hiddenPromo) => {
    if (experienceTag === 'BOGO') {
      return (hiddenPromo === subExperienceTag);
    }
    return (hiddenPromo === experienceTag);
  });
});
